import * as React from 'react';

import OptOutModalGraphicSVG from './opt-out-modal-graphic.svg';

import styles from './message-modal-graphic.module.css';

export function OptOutModalGraphic() {
    return (
        <div className={styles.container}>
            <OptOutModalGraphicSVG width={116} />
        </div>
    );
}
